import { mapLocationIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const WorkerTrackingAlt = createIcon({
  displayName: 'WorkerTrackingAlt',
  paths: [
    'M512.009 85.333c-188.501 0-341.333 159.189-341.333 355.541 0 196.395 341.333 497.792 341.333 497.792s341.333-301.397 341.333-497.792c0-196.352-152.832-355.541-341.333-355.541zM512.009 170.667c141.141 0 256 121.216 256 270.208 0 93.483-135.509 262.571-256 381.013-120.491-118.443-256-287.531-256-381.013 0-148.992 114.816-270.208 256-270.208zM512 298.667c-35.371 0-64 28.629-64 64s28.629 64 64 64h-64c-35.371 0-64 28.629-64 64s28.629 64 64 64h128c35.371 0 64-28.629 64-64s-28.629-64-64-64h-64c35.371 0 64-28.629 64-64s-28.629-64-64-64z'
  ],
  canvasPaths: canvasIconPaths(mapLocationIcon)
})
